<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    :element-loading-text="$t('Please wait')"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/comSalesIndex/cRetailOrderList' }"
          >{{ $t('Retail business management center') }}</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/comSalesIndex/cRetailOrderDetail' }"
          >{{ $t('Order details') }}</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{$t('Receiving management')}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!--  主要内容 start -->
    <div class="form_container">
      <div class="content_wrap flex-rowl">
        <div class="tip_wrap shop_first">
          <div class="item">
            <h1>{{$t('Order number')}}：</h1>
            <p>{{ dataItem.orderno }}</p>
          </div>
          <div class="item">
            <h1>{{$t('Creation time')}}：</h1>
            <p>{{ dataItem.createdate | formatDate }}</p>
          </div>
          <div class="item">
            <h1>{{$t('Sales specialist name')}}：</h1>
            <p>{{ dataItem.salerstr }}</p>
          </div>
          <div class="item">
            <h1>{{$t('Order area')}}：</h1>
            <p>{{ dataItem.inarea }}</p>
          </div>
          <div class="item">
            <h1>{{$t('Order source channel')}}：</h1>
            <p>{{ dataItem.channelidstr }}</p>
          </div>
        </div>
        <div class="tip_wrap shop_wrap">
          <div class="item shop_item flex-rowl">
            <div
              class="block"
              v-for="(item, index) in dataItem.goods"
              :key="index"
            >
              <h1>
                {{$t('Product name')}}：<span>{{ item.commodityname }}</span>
              </h1>
              <h1>
               {{$t('Product ID')}}：<span>{{ item.id }}</span>
              </h1>
              <h1>
                {{$t('Product SKU')}}：<span>{{ item.sku }}</span>
              </h1>
              <h1>
                <p v-for="(label, labelIndex) in item.attr" :key="labelIndex">
                  <span>{{ label }}</span>
                  <!-- <span>：{{ item.attrPrice }}/件</span> -->
                </p>
              </h1>
              <h1>
                {{$t('Quantity of products')}}：<span>{{ item.num }}</span>
              </h1>
              <!-- <h1>
                价格小计：<span>{{ item.newPrice | formatPrice }}</span>
              </h1> -->
              <h1>{{$t('Product type')}}：<span>{{ $t('Main products') }}</span></h1>
              <template v-if="item.orderGood.msgtype == 2">
                <h1>
                  {{$t('Recipient')}}：<span>{{ item.orderGood.msgman }}</span>
                </h1>
                <h1>
                  {{$t('Recipient contact information')}}：<span>{{ item.orderGood.msglink }}</span>
                </h1>
                <h1>
                  {{$t('Province/municipality directly under the Central Government')}}：<span>{{ item.orderGood.msgaddr }}</span>
                </h1>
              </template>
            </div>
            <div
              class="block"
              v-for="(item, index) in dataItem.goods_pei"
              :key="index"
            >
              <h1>
                {{$t('Product name')}}：<span>{{ item.commodityname }}</span>
              </h1>
              <h1>
                {{$t('Product ID')}}：<span>{{ item.id }}</span>
              </h1>
              <h1>
                {{$t('Product SKU')}}：<span>{{ item.sku }}</span>
              </h1>
              
              <h1>
                {{$t('Quantity of products')}}：<span>{{ item.num }}</span>
              </h1>
              <!-- <h1>
                价格小计：<span>{{ item.newPrice }}</span>
              </h1> -->
              <h1>{{$t('Product type')}}：<span>{{ $t('Accessories') }}</span></h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" :class="{disabled : dataItem.orderstate != '已发货'}" @click="handleSubmit">{{ $t('Confirm that all products have been received') }}</div>

      <div class="return_txt" @click="handleReturn">←{{ $t('Return') }}</div>
    </div>
    <!--  主要内容 end -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { encryptstringview } from "../../../api/api";
import { getOrderListDetail, getSubmitShop } from "../../../api/shop";
import { calculator } from "../../../utils/decimal";
import { mapState } from "vuex";
export default {
  name: "cPaymentReceiveGoods",
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      creenIndex: "",
      picsList: [],
      loading: false,
      dataItem: "",
      type: "",
      orderId: "",
      orderOpenid: "",
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
    // 价格逗号分隔，保留两位小数
    formatPrice(price) {
      if (!price) "0.00";
      const formattedPrice = Number(price)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return formattedPrice;
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { orderId, orderOpenid } = JSON.parse(res.jsondata);
        this.orderId = orderId;
        this.orderOpenid = orderOpenid;
        this.getOrderListDetail(orderId, orderOpenid);
      } else {
        this.$router.back();
      }
    },
    // 订单列表
    getOrderListDetail(orderId, openid) {
      let params = {
        openid: openid,
        orderid: orderId,
      };
      this.loading = true;
      getOrderListDetail(params).then((res) => {
        let newObj = res[0];
        let newGoods =
          newObj.goodsjson != "" && newObj.goodsjson
            ? JSON.parse(newObj.goodsjson)
            : "";
        if (newObj.goods.length > 0) {
          newObj.goods.forEach((v1, index) => {
            v1.attr = v1.attr != "" ? JSON.parse(v1.attr) : v1.attr;
            if (newGoods != "") {
              v1.orderGood = newGoods[index];
              // 单件商品总价 (零售价 +/- 标签价) * 数量  后续加入折扣价针对于第一个商品
              let attrPrice =
                v1.orderGood.attrnumtype == "不变"
                  ? 0
                  : v1.orderGood.attrnumtype == "减少"
                  ? "-" + v1.orderGood.attrnum
                  : v1.orderGood.attrnum;

              v1.attrPrice =
                v1.orderGood.attrnumtype == "不变"
                  ? "¥" + 0
                  : v1.orderGood.attrnumtype == "减少"
                  ? "- ¥" + v1.orderGood.attrnum
                  : "+ ¥" + v1.orderGood.attrnum;
              v1.newPrice = calculator(calculator(v1.price).add(attrPrice))
                .multiply(v1.num)
                .toNumber();
            } else {
              v1.newPrice = calculator(v1.price).multiply(v1.num).toNumber();
            }
          });
        }
        if (newObj.goods_pei.length > 0) {
          newObj.goods_pei.forEach((v1) => {
            v1.newPrice = calculator(v1.price).multiply(v1.num).toNumber();
          });
        }

        this.picsList = newObj.pics ? newObj.pics.split(",") : '';
        this.dataItem = newObj;
        this.loading = false;
      });
    },

    handleReturn() {
      this.$router.back();
    },

    // 确认是否收货
    handleSubmit() {
      let {dataItem} = this
      if(dataItem.orderstate != '已发货') return
      this.$alert(this.$t('Confirm receipt of goods'), "", {
        confirmButtonText: "OK",
        callback: (action) => {
          if (action == "confirm") {
            this.getSubmitShop()
          }
        },
      });
    },

    getSubmitShop() {
      let params = {
        openid: this.OPENID,
        orderid: this.orderId
      };
      this.loading = true
      getSubmitShop(params).then((res) => {
        if(res.result) {
          this.loading = false
          this.$message.success(res.message)
        }else {
          this.$message.error(res.message)
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.page_container {
  .form_container {
    align-items: flex-start;
    flex-flow: wrap;
    padding: 39px 20px 80px 70px;
    height: 67vh;
    .content_wrap {
      .form_wrap {
        margin-right: 100px;
      }
      .tip_wrap {
        // flex-shrink: 0;
        width: calc(35% / 2);
        // &:first-child {
        //   flex-shrink: 0;
        //   width: 30%;
        // }
        &.shop_first {
          width: 14%;
        }
        &.shop_wrap {
          flex-shrink: 0;
          width: 83%;
          margin: 0 0 0 2%;
        }
        &.order_state_wrap {
          flex-shrink: 0;
          width: 13%;
          margin: 0 2% 0 2%;
        }
        &.shop_last {
          width: 25%;
        }
        .item {
          margin-bottom: 15px;
          color: #6e6e6e;
          h1 {
            margin-bottom: 8px;
            font-size: 18px;
            // white-space: nowrap;
          }
          &.shop_item {
            width: 100%;
            font-size: 14px;
            flex-flow: wrap;
            h1 {
              font-size: 16px;
              span {
                color: #6e6e6e;
                font-size: 14px;
                // white-space: pre-wrap;
                word-break: break-all;
              }
            }
            .block {
              width: calc((100% - 60px) / 3);
              margin-bottom: 20px;
              border: 1px solid #ccc;
              padding: 20px;
              box-sizing: border-box;
              border-radius: 35px;
              &:nth-child(3n-1) {
                margin: 0 30px;
              }
            }
          }
          p {
            &.red {
              color: red;
            }
          }
          &.pay_item {
            p {
              margin-bottom: 5px;
            }
          }
        }
        .upload_list {
          flex-wrap: wrap;
          .upload_box {
            width: calc((100% - 25px) / 4);
            height: 100px;
            margin-right: 5px;
            margin-bottom: 10px;
            border: 1px dashed #c0ccda;
            border-radius: 5px;
            cursor: pointer;
            position: relative;
            &:nth-child(4n) {
              margin-right: 0;
            }
            .upload_item {
              height: 100%;
              width: 100%;
              position: relative;
              img {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
              }
            }
            .custom-upload {
              .el-upload--picture-card {
                // width: 120px;
                // height: 120px;
              }
            }
            .el-upload-list__item-actions span {
              &:last-child {
                margin-left: 0;
              }
            }

            &:last-child {
              margin-right: 0;
            }
          }
          .custom_upload {
            background-color: #fbfdff;
            border: 1px dashed #c0ccda;
            border-radius: 6px;
            box-sizing: border-box;
            width: 148px;
            height: 148px;
            cursor: pointer;
            line-height: 146px;
            vertical-align: top;
            cursor: pointer;
            input {
              opacity: 0;
              width: 100%;
              height: 100%;
              position: relative;
              z-index: 10;
              cursor: pointer;
            }
            .avatar-uploader-icon {
              font-size: 28px;
              color: #8c939d;
              z-index: 9;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }
      }
    }
  }
  .form_footer {
    .btn {
      width: auto;
      padding: 0 30px;
      box-sizing: border-box;
      &:nth-child(2n) {
        margin: 0 30px;
      }
      &.disabled {
        background: #a6a6a6;
      }
    }
  }
}
</style>